module.exports = __webpack_public_path__ + "static/media/upload-resume.fe815f18.svg";